// app/javascript/application.js

import "@hotwired/turbo-rails"
import "./controllers"
import AOS from "aos"

const scrollTargetTop = (target) => {
  if (typeof target === "number") return target

  const scrollMarginTop = Number.parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0

  return target.getBoundingClientRect().top + window.scrollY - scrollMarginTop
}

const smoothScrollTo = (target) => {
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
  const targetTop = Math.max(0, scrollTargetTop(target))

  if (prefersReducedMotion) {
    window.scrollTo({ top: targetTop, behavior: "auto" })
    return
  }

  window.scrollTo({ top: targetTop, behavior: "smooth" })
}

const initialAnchorHash = () => {
  return window.amperdotInitialHash || null
}

const restoreInitialAnchor = () => {
  if (document.body?.classList.contains("is-admin")) return

  const hash = initialAnchorHash()
  if (!hash) return

  const target = document.getElementById(hash.slice(1))
  if (!target) return

  window.amperdotInitialHash = null

  smoothScrollTo(target)
  window.history.replaceState(window.history.state, "", `${window.location.pathname}${window.location.search}${hash}`)
}

const scheduleInitialAnchorRestore = () => {
  if (!initialAnchorHash()) return

  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(restoreInitialAnchor)
  })
}

document.addEventListener("turbo:load", () => {
  document.documentElement.classList.add("js-aos")

  AOS.init({
    duration: 650,
    easing: "ease-out-cubic",
    offset: 28,
    once: true,
    mirror: false
  })

  scheduleInitialAnchorRestore()
})

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", scheduleInitialAnchorRestore, { once: true })
} else {
  scheduleInitialAnchorRestore()
}

document.addEventListener("turbo:render", () => {
  AOS.refresh()
})
